function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { ConnectionType, EffectiveType } from '@sky-uk-ott/client-lib-js-device';
import { ConvivaConnectionType } from './conviva-addon.enums';
export { ConvivaConnectionType } from './conviva-addon.enums';
var _obj;
var CONVIVA_CONNECTION_TYPE_ADAPTER = (_obj = {}, _define_property(_obj, ConnectionType.Ethernet, ConvivaConnectionType.WIRED), _define_property(_obj, ConnectionType.Wifi, ConvivaConnectionType.WIRELESS), _define_property(_obj, EffectiveType['2G'], ConvivaConnectionType.CELLULAR_2G), _define_property(_obj, EffectiveType['3G'], ConvivaConnectionType.CELLULAR_3G), _define_property(_obj, EffectiveType['4G'], ConvivaConnectionType.CELLULAR_4G), _define_property(_obj, ConnectionType.Unknown, ConvivaConnectionType.UNKNOWN), _obj);
export function getConvivaNetworkInformation(deviceNetworkStatus) {
    if (!deviceNetworkStatus) {
        return;
    }
    var internalConnectionType = deviceNetworkStatus.getNetworkConnectionType();
    var _CONVIVA_CONNECTION_TYPE_ADAPTER_internalConnectionType;
    return {
        connectionType: (_CONVIVA_CONNECTION_TYPE_ADAPTER_internalConnectionType = CONVIVA_CONNECTION_TYPE_ADAPTER[internalConnectionType]) !== null && _CONVIVA_CONNECTION_TYPE_ADAPTER_internalConnectionType !== void 0 ? _CONVIVA_CONNECTION_TYPE_ADAPTER_internalConnectionType : ConvivaConnectionType.UNKNOWN
    };
}

//# sourceMappingURL=conviva-network-adapter.js.map